import { Fragment } from 'react';
import styled from 'styled-components';
import { Row, Col } from 'antd';

import { IFlat } from '../../common/model/flat.model';
import useI18n from '../../common/hooks/useI18n';

type Props = {
  flat: IFlat;
  className?: string;
};

const FeatureOneCol = styled(Col)`
  padding-bottom: 16px;
  border-bottom: 1px solid ${(props) => props.theme.colors.grey};
`;

const FeatureTwoCol = styled(Col)`
  padding-bottom: 16px;
  border-bottom: 1px solid ${(props) => props.theme.colors.grey};
`;

const FeatureThreeCol = styled(Col)`
  padding-bottom: 16px;
  border-bottom: 1px solid ${(props) => props.theme.colors.grey};
`;

const FeatureFourCol = styled(Col)`
  padding-bottom: 16px;
  border-bottom: 1px solid ${(props) => props.theme.colors.grey};
`;

const FeatureFiveCol = styled(Col)`
  padding-bottom: 16px;
  border-bottom: 1px solid ${(props) => props.theme.colors.grey};

  @media ${(props) => props.theme.breakpoints.md} {
    padding-bottom: 0;
    border-bottom-width: 0;
  }

  @media ${(props) => props.theme.breakpoints.sm} {
    padding-bottom: 0;
    border-bottom-width: 0;
  }
`;

const FeatureSixCol = styled(Col)`
  padding-bottom: 16px;
  border-bottom: 1px solid ${(props) => props.theme.colors.grey};

  @media ${(props) => props.theme.breakpoints.md} {
    padding-bottom: 0;
    border-bottom-width: 0;
  }

  @media ${(props) => props.theme.breakpoints.sm} {
    padding-bottom: 0;
    border-bottom-width: 0;
  }
`;

const FeatureSevenCol = styled(Col)`
  border-bottom-width: 0;
`;

const FeatureEightCol = styled(Col)`
  border-bottom-width: 0;
`;

const FeatureTitle = styled.div`
  font-size: 14px;
  @media ${(props) => props.theme.breakpoints.xs} {
    font-size: 12px;
  }
  font-weight: 600;
`;

const FeatureInfo = styled.div`
  margin-top: 1rem;
  font-size: 14px;
  @media ${(props) => props.theme.breakpoints.xs} {
    font-size: 12px;
  }
`;

const FeaturesCard = ({ flat, className }: Props): JSX.Element => {
  const i18n = useI18n();

  return (
    <div className={className}>
      <Row gutter={[16, 16]}>
        <FeatureOneCol xs={12} sm={6} lg={12}>
          <FeatureTitle>{i18n.t('flat.rooms')}</FeatureTitle>
          <FeatureInfo>{flat.rooms}</FeatureInfo>
        </FeatureOneCol>
        <FeatureTwoCol xs={12} sm={6} lg={12}>
          <FeatureTitle>{i18n.t('flat.bathrooms')}</FeatureTitle>
          <FeatureInfo>{flat.bathrooms}</FeatureInfo>
        </FeatureTwoCol>
        <FeatureThreeCol xs={12} sm={6} lg={12}>
          <FeatureTitle>{i18n.t('flat.sqrMeters')}</FeatureTitle>
          <FeatureInfo>
            {flat.sqrMeters} m
            <sup style={{ verticalAlign: 'top', fontSize: '0.6em' }}>2</sup>
          </FeatureInfo>
        </FeatureThreeCol>
        <FeatureFourCol xs={12} sm={6} lg={12}>
          <FeatureTitle>{i18n.t('flat.elevator')}</FeatureTitle>
          <FeatureInfo>
            {flat.hasElevator ? i18n.t('messages.yes') : i18n.t('messages.no')}
          </FeatureInfo>
        </FeatureFourCol>
        <FeatureFiveCol xs={12} sm={6} lg={12}>
          <FeatureTitle>{i18n.t('flat.garden')}</FeatureTitle>
          <FeatureInfo>
            {flat.hasGarden ? i18n.t('messages.yes') : i18n.t('messages.no')}
          </FeatureInfo>
        </FeatureFiveCol>
        <FeatureSixCol xs={12} sm={6} lg={12}>
          <FeatureTitle>{i18n.t('flat.terrace')}</FeatureTitle>
          <FeatureInfo>
            {flat.hasTerrace ? i18n.t('messages.yes') : i18n.t('messages.no')}
          </FeatureInfo>
        </FeatureSixCol>
        <FeatureSevenCol xs={12} sm={6} lg={12}>
          <FeatureTitle>{i18n.t('flat.garage')}</FeatureTitle>
          <FeatureInfo>
            {flat.hasGarage ? i18n.t('messages.yes') : i18n.t('messages.no')}
          </FeatureInfo>
        </FeatureSevenCol>
        <FeatureEightCol xs={12} sm={6} lg={12}>
          {flat.hasSwimmingPool && (
            <Fragment>
              <FeatureTitle>{i18n.t('flat.swimmingPool')}</FeatureTitle>
              <FeatureInfo>
                {flat.hasSwimmingPool
                  ? i18n.t('messages.yes')
                  : i18n.t('messages.no')}
              </FeatureInfo>
            </Fragment>
          )}
        </FeatureEightCol>
      </Row>
    </div>
  );
};

export default styled(FeaturesCard)`
  -webkit-box-shadow: 0px 6px 21px -4px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0px 6px 21px -4px rgba(0, 0, 0, 0.25);
  box-shadow: 0px 6px 21px -4px rgba(0, 0, 0, 0.25);
  border-radius: 32px;
  padding: 2rem;
`;
